<template>
  <div class="card-body">

    <div class="search-wrap">
      <el-button size="mini" type="primary" @click="editArticle()" style="margin-right: 5px;" icon="el-icon-plus">添加</el-button>
      <el-select v-model="config_id" placeholder="选择公司">
        <el-option
          label="--全部"
          value="">
        </el-option>
        <el-option
          v-for="item2 in config_list"
          :key="item2.id"
          :label="item2.company_name"
          :value="item2.id">
        </el-option>
      </el-select>
      <el-select v-model="type" size="mini" clearable="" placeholder="选择类型" style="width: 150px">
        <el-option label="公司介绍" value="intro"></el-option>
        <el-option label="产品介绍" value="product"></el-option>
      </el-select>
      <el-input size="mini" placeholder="请输入搜关键字" v-model="keyword" clearable style="width: 200px"></el-input>
      <el-button size="mini" type="primary" @click="search">搜索</el-button>
    </div>

    <div class="table-wrap">
      <el-table v-loading="loading" :data="tableData">
        <el-table-column prop="title" label="标题" align="center"></el-table-column>
        <el-table-column prop="type" label="类型" align="center"></el-table-column>
        <el-table-column prop="image" label="图片" align="center">
          <template slot-scope="scope">
            <el-image :src="getImagePath(scope.row.image)" style="width: 40px;height: 40px;"></el-image>
          </template>
        </el-table-column>
        <!--      <el-table-column prop="description" label="简介" align="center"></el-table-column>-->
        <el-table-column prop="sort" label="排序" align="center"></el-table-column>
        <el-table-column label="操作" align="center" width="180">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" icon="el-icon-edit" @click="editArticle(scope.row)">修改</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination-wrap">
      <el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize" :current-page="page" @current-change="pageChange"></el-pagination>
    </div>

    <!-- 修改窗口 -->
    <el-dialog title="内容修改" :visible.sync="dialogVisible" width="1000px">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px" size="mini" style="margin-right: 50px;">
        <el-form-item label="公司" prop="title">
          <el-select v-model="form.config_id" placeholder="选择公司">
            <el-option
              v-for="item2 in config_list"
              :key="item2.id"
              :label="item2.company_name"
              :value="item2.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="form.type" placeholder="请选择">
            <el-option label="公司介绍" value="intro"></el-option>
            <el-option label="产品介绍" value="product"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input class="form-input" v-model="form.title" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="简介" prop="description">
          <el-input type="textarea" rows="5" v-model="form.description" autocomplete="off" style="width: 450px;"></el-input>
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <!--        <el-input v-model="form.content" autocomplete="off"></el-input>-->
          <HtmlEditor :data-content="form.content" style="width: 500px" :content="form.content" :host-url="host_rul" :upload-url="upload_url" @onEditor="onEditor" />
        </el-form-item>
        <el-form-item label="图片" prop="image">
          <!--        <el-upload-->
          <!--          class="upload-demo"-->
          <!--          :action="uploadUrl"-->
          <!--          :on-remove="handleRemove"-->
          <!--          :on-success="uploadSuccess"-->
          <!--          :on-error="uploadError"-->
          <!--          :file-list="fileList"-->
          <!--          :limit="1"-->
          <!--          list-type="picture">-->
          <!--          <el-button size="small" type="primary">点击上传</el-button>-->
          <!--          <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过1mb</div>-->
          <!--        </el-upload>-->
          <UploadFileSysc v-model="form.image" :host-url="host_rul" :upload-url="uploadUrl"></UploadFileSysc>
        </el-form-item>
        <el-form-item label="链接" prop="link">
          <el-input class="form-input" v-model="form.link" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input class="form-input" v-model="form.sort" autocomplete="off"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" :loading="formLoading">确 定</el-button>
      </div>
    </el-dialog>

  </div>

</template>

<script>

  import { Loading } from 'element-ui';
  import { getImagePath, Article,getBaseURL } from './common.js'
  import HtmlEditor from "./HtmlEditor";
  import UploadFileSysc from "./components/UploadFileSysc";
  import CardLayout from "./components/CardLayout";
  import xhHelp from "./xhHelp";

export default {
  name: "CardArticle",
  components: {CardLayout, UploadFileSysc, HtmlEditor},
  data () {
    return {
      type: '',
      keyword: '',
      loading: false,
      tableData: [],
      config_id:"",
      page: 1,
      pageSize: 10,
      total: 0,
      form: this.getFormData(),
      rules: {
        title: [
          { required: true, message: '请填写标题', trigger: 'blur' },
        ],
      },
      dialogVisible: false,
      formLoading: false,
      uploadUrl: Article.getUploadUrl(),
      fileList: [],
      host_rul:getBaseURL(),
      upload_url:Article.getUploadFile(),
      getImagePath:getImagePath,
      config_list:[]
    }
  },
  created() {

    this.getList();
    this.getConfigList();

  },
  watch: {
    dialogVisible(val) {
      if(val == false) {
        this.fileList = []
      }
    }

  },
  methods: {
    getFormData(data) {
      return Object.assign({
        id: '',
        type: '',
        config_id:"",
        title: '',
        description: '',
        content: '',
        image: '',
        link: '',
        sort: '',
      }, data)
    },
    search() {
      this.page = 1
      this.getList()
    },
    getList() {
      Article.getList({
        type: this.type,
        keyword: this.keyword,
        config_id:this.config_id,
        page: this.page,
        page_size: this.pageSize
      }, res => {
        if(res.code == 0) {
          this.total = res.data.total
          this.tableData = res.data.data
        }
      })
    },
    pageChange(i) {
      this.page = i
      this.getList()
    },
    editArticle(item) {

      this.fileList = []

      if(!item) {
        this.form = this.getFormData({type: 'product'})
      } else {

        if(item.image) {
          this.fileList.push({name: '', url: getImagePath(item.image)})
        }

        this.form = item
      }
      this.dialogVisible = true
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.formLoading = true
          let data = Object.assign({}, this.form)
          // console.log(data)
          Article.save(data, res => {
            this.$message({type: res.code == 0 ? 'success': 'error', message: res.msg})
            if(res.code == 0) {
              this.dialogVisible = false
              this.getList()
            }
            this.formLoading = false
          })
        } else {
          return false;
        }
      });
    },

    uploadSuccess(response, file, fileList) {
      this.form.image = file.response.data.path
    },

    uploadError(response, file, fileList) {
      this.$message.error("上传失败")
    },

    handleRemove(file, fileList) {
      this.form.image = ''
    },
    onEditor({ editor, html, text }){
      this.form.content=html;
      this.form.description=text;
    },
    getConfigList(){
      const  that=this;
      xhHelp.get('Config/getConfigList',{
        page:0,
        page_size:200
      },ret=>{
        if(ret.code){
          that.config_list=ret.data
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>

  @import './common.scss';

  .form-input {
    width: 300px;
  }

</style>



// WEBPACK FOOTER //
// src/components/Admin/App/Card/Article.vue